// Feature switches (set in Netlify build environment variables, then redeploy).
//
// REACT_APP_ADS_ENABLED=false  -> turns ALL ads off and hides the Advertising
//                                 choice in the cookie banner.
// Default (unset) = ads on. Use "false" if you decide to stay ad-free until you
// have a commercial agreement with TMDB (see docs/BUSINESS_CHECKLIST.md).
export const ADS_ENABLED = process.env.REACT_APP_ADS_ENABLED !== "false";

// The ONE rule for showing ads: the site must have ads on AND the visitor must
// have agreed to advertising. Used by every ad component.
export const canShowAds = (consent, enabled = ADS_ENABLED) =>
  !!enabled && !!consent?.advertising;
